export default __webpack_public_path__ + "static/media/im-title-cn.52f3f732.webp";